export const DEFAULT_SESSION_IDLE_TIMEOUT_MINUTES = 30;
export const B2G_SESSION_IDLE_TIMEOUT_MINUTES = 15;

export function defaultSessionIdleTimeoutMinutes(dhdaB2gEnabled: boolean): number {
  return dhdaB2gEnabled ? B2G_SESSION_IDLE_TIMEOUT_MINUTES : DEFAULT_SESSION_IDLE_TIMEOUT_MINUTES;
}

export function configuredSessionIdleTimeoutMs(
  configuredMinutes: number | null,
  defaultMinutes = DEFAULT_SESSION_IDLE_TIMEOUT_MINUTES,
): number {
  return (
    (configuredMinutes !== null &&
    Number.isInteger(configuredMinutes) &&
    configuredMinutes >= 5 &&
    configuredMinutes <= 120
      ? configuredMinutes
      : defaultMinutes) *
    60 *
    1000
  );
}
